import React from 'react'

import { FaStar,FaUser } from "react-icons/fa";

import course1 from '../../assets/images/course-1.jpg'
import course2 from '../../assets/images/stocks-3.jpg'
import course3 from '../../assets/images/stocks-2.jpg'
import course4 from '../../assets/images/stocks-1.jpg'

function Courses_Section() {
  return (
    <div>
      
      <div class="blogarea__2 sp_top_30 sp_bottom_50">
            <div class="container">
                <div class="row">
                    <div class="col-xl-12 aos-init aos-animate" data-aos="fade-up">
                    <div class="section__title text-center aos-init aos-animate sp_bottom_30" data-aos="fade-up">
                        <div class="section__title__button">
                            <div class="default__small__button">Our Courses</div>
                        </div>
                        <div class="section__title__heading heading__underline">
                            <h2> Master the <span>Markets</span>
                           <br />  with Our Expert Programs</h2>
                        </div>
                    </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 aos-init aos-animate" data-aos="fade-up">
                        <div class="single__blog__wraper gridarea__wraper">
                            <div class="single__blog__img  gridarea__img">
                                <img loading="lazy" src={course1} alt="blog"/>
                              
                                <div class="gridarea__small__button ">
                                    <div class="grid__badge"><a href="/foundation">Basic Programs</a></div>
                                </div>

                            </div>


                            <div class="single__blog__content">
                            <a href="/foundation"><p className='fs-4'>The Foundation</p></a>
                                <h6 className='fw-normal multiline-ellipsis'>Learn the essentials of stock trading with live and recorded sessions, covering market structure, trading mechanisms, and investment strategies tailored to your needs.</h6>
                                <div class="single__blog__bottom__button">
                                 
                           <div class="gridarea__bottom">


    <div class="gridarea__small__img">
     
    
        <div className='course-price-box'>
        <div class="gridarea__price">
            <p className='course-price'>&#8377; 9,999 + GST</p>
                <del className='text-secondary'>20,000 + GST</del>
             </div>
             <div>
             <div class="blogarea__bottom__button">
                            <a class="default__button py-2 px-4" href="#">Buy Now</a>
                        </div>

             </div>
        </div>

        

    </div>



</div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 aos-init aos-animate" data-aos="fade-up">
                        <div class="single__blog__wraper gridarea__wraper">
                            <div class="single__blog__img gridarea__img">
                                <img loading="lazy" src={course2} alt="blog"/>
                                <div class="gridarea__small__button ">
                                    <div class="grid__badge"><a href="/technical-analysis">Basic Programs</a></div>
                                </div>

                            </div>
                            <div class="single__blog__content">
                            <a href="/technical-analysis"><p className='fs-5'>Technical Analysis</p></a>
                                <h6 className='fw-normal multiline-ellipsis'>Dive into charts, candlesticks, patterns, and indicators to analyze market trends and make informed trading decisions.</h6>
                                <div class="single__blog__bottom__button">
                                 
                           <div class="gridarea__bottom">


    <div class="gridarea__small__img">
     
      

    <div className='course-price-box'>
        <div class="gridarea__price">
            <p className='course-price'>&#8377; 9,999 + GST</p>
                <del className='text-secondary'>20,000 + GST</del>
             </div>
             <div>
             <div class="blogarea__bottom__button">
                            <a class="default__button py-2 px-4" href="#">Buy Now</a>
                        </div>

             </div>
        </div>

        

    </div>



</div>

                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 aos-init aos-animate" data-aos="fade-up">
                        <div class="single__blog__wraper gridarea__wraper">
                            <div class="single__blog__img gridarea__img">
                                <img loading="lazy" src={course3} alt="blog"/>
                                <div class="gridarea__small__button ">
                                    <div class="grid__badge"><a href="/future-options">Basic Programs</a></div>
                                </div>

                            </div>
                            <div class="single__blog__content">
                            <a href="/future-options"><p className='fs-4'>Futures & Options</p></a>
                                <h6 className='fw-normal multiline-ellipsis'>Explore the world of Futures & Options, understand how they work, and learn to use them strategically to maximize your trading potential and financial growth.</h6>
                                <div class="single__blog__bottom__button">
                                 
                           <div class="gridarea__bottom">


    <div class="gridarea__small__img">
     
      

    <div className='course-price-box'>
        <div class="gridarea__price">
            <p className='course-price'>&#8377; 9,999 + GST</p>
                <del className='text-secondary'>20,000 + GST</del>
             </div>
             <div>
             <div class="blogarea__bottom__button">
                            <a class="default__button py-2 px-4" href="#">Buy Now</a>
                        </div>

             </div>
        </div>

        

    </div>



</div>

                                </div>
                            </div>
                        </div>
                    </div>



                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 aos-init aos-animate" data-aos="fade-up">
                        <div class="single__blog__wraper gridarea__wraper">
                            <div class="single__blog__img gridarea__img">
                                <img loading="lazy" src={course4} alt="blog"/>
                                <div class="gridarea__small__button ">
                                    <div class="grid__badge"><a href="/adv-technical-analysis">Advance Programs</a></div>
                                </div>

                            </div>
                            <div class="single__blog__content">
                            <a href="/adv-technical-analysis"><p className='fs-5'>Advance Technical Analysis</p></a>
                                <h6 className='fw-normal multiline-ellipsis'>Enter the world of professional trading, where data meets strategy. This program takes you beyond the basics, giving you the skills to think and trade like an institutional player.</h6>
                                <div class="single__blog__bottom__button">
                                 
                           <div class="gridarea__bottom">


    <div class="gridarea__small__img">
     
      

    <div className='course-price-box'>
        <div class="gridarea__price">
            <p className='course-price'>&#8377; 19,999 + GST</p>
                <del className='text-secondary'>30,000 + GST</del>
             </div>
             <div>
             <div class="blogarea__bottom__button">
                            <a class="default__button py-2 px-4" href="#">Buy Now</a>
                        </div>

             </div>
        </div>

        

    </div>



</div>

                                </div>
                            </div>
                        </div>
                    </div>




                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 aos-init aos-animate" data-aos="fade-up">
                        <div class="single__blog__wraper gridarea__wraper">
                            <div class="single__blog__img gridarea__img">
                                <img loading="lazy" src={course3} alt="blog"/>
                                <div class="gridarea__small__button ">
                                    <div class="grid__badge"><a href="/adv-options-strategies">Advance Programs</a></div>
                                </div>
                            </div>
                            <div class="single__blog__content">
                            <a href="/adv-options-strategies"><p className='fs-5'>Advance Option Strategies</p></a>
                                <h6 className='fw-normal multiline-ellipsis'>Enter the world of options and strategic trading, where professionals unlock limitless possibilities. Master the art of leveraging market movements with precision and confidence.</h6>
                                <div class="single__blog__bottom__button">
                                 
                           <div class="gridarea__bottom">


    <div class="gridarea__small__img">
     


    <div className='course-price-box'>
        <div class="gridarea__price">
            <p className='course-price'>&#8377; 19,999 + GST</p>
                <del className='text-secondary'>30,000 + GST</del>
             </div>
             <div>
             <div class="blogarea__bottom__button">
                            <a class="default__button py-2 px-4" href="#">Buy Now</a>
                        </div>

             </div>
        </div>

        

    </div>



</div>

                                </div>
                            </div>
                        </div>
                    </div>





                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 aos-init aos-animate" data-aos="fade-up">
                        <div class="single__blog__wraper gridarea__wraper">
                            <div class="single__blog__img gridarea__img">
                                <img loading="lazy" src={course1} alt="blog"/>
                                <div class="gridarea__small__button ">
                                    <div class="grid__badge"><a href="/forex-trading">Advance Programs</a></div>
                                </div>
                            </div>
                            <div class="single__blog__content">
                            <a href="/forex-trading"><p className='fs-5'>Forex Trading</p></a>
                                <h6 className='fw-normal multiline-ellipsis'>Gain an institutional edge in the world's largest financial market with our Forex Trading. Master how global banks and hedge funds trade currencies across key sessions (Tokyo, London, New York).</h6>
                                <div class="single__blog__bottom__button">
                                 
                           <div class="gridarea__bottom">


    <div class="gridarea__small__img">
     
        {/* <div class="gridarea__small__content d-flex justify-content-between px-4 align-items-center">
           <div>
           <FaUser/> &nbsp;<span>25000</span>
           </div> |
            <div class="gridarea__star ">
            <FaStar style={{color:'#fb6107'}}/>&nbsp;
    <FaStar style={{color:'#fb6107'}}/>&nbsp;
    <FaStar style={{color:'#fb6107'}}/>&nbsp;
    <FaStar style={{color:'#fb6107'}}/>&nbsp;
    <FaStar style={{color:'#fb6107'}}/>&nbsp;
  
</div>
        </div> */}

<div className='course-price-box'>
        <div class="gridarea__price">
            <p className='course-price'>&#8377; 24,999 + GST</p>
                <del className='text-secondary'>40,000 + GST</del>
             </div>
             <div>
             <div class="blogarea__bottom__button">
                            <a class="default__button py-2 px-4" href="#">Buy Now</a>
                        </div>

             </div>
        </div>

        

    </div>



</div>

                                </div>
                            </div>
                        </div>
                    </div>








                    {/* <div class="col-xl-12 aos-init aos-animate" data-aos="fade-up">
                        <div class="blogarea__bottom__button">
                            <a class="default__button" href="#">MORE BLOG</a>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>

    </div>
  )
}

export default Courses_Section
